import PostSite from "../../SiteNew/model/PostSite";
import axiosApi from "../../../../components/Api/Axios";
import BackendServices from "../../../../components/Api/BackendService";

export default (payload: PostSite): Promise<string> =>
  axiosApi
    .put(`${BackendServices.COMPANY_SERVICE.SITES}/${payload.site.id}`, payload)
    .then(() => `${payload.site.id}`);
